//#region Old Code

// import React from "react";
// import { AGENTS } from "../../consts/tables";
// import AgentInfo from "./AgentInfo";
// import { browserHistory } from "react-router";
// import CRUD from "../CRUD/CRUD";
// import FirmDrawer from "../FirmDrawer/FirmDrawer";
// import Drawer from "../Drawer";
// import { getData, manageData } from "../../requests/CRUD";
// import request from 'arcdynamic-request';

// const limit = 1000;
// export default class CRUDAgent extends React.Component {
//   drawerComponentRef;

//   constructor(props) {
//     super(props);

//     this.state = {
//       data: null,
//       original: null,
//       isBusy: null,
//       error: null,
//       success: null,
//       newFirm: false,
//       isExists:false,
//       errorTabs: [],
//       users:[],
//       currentTab: 0,
//       viewMode: this.props.edit || false,
//       showDrawer: false,
//       addNewItemType: null,
//       resetDrawer: false
//     };

//     this.handleSubmit = this.handleSubmit.bind(this);
//     this.handleChangeInput = this.handleChangeInput.bind(this);
//     this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
//     this.saveData = this.saveData.bind(this);
//     this.addNewItem = this.addNewItem.bind(this);
//     this.savedNewFirm = this.savedNewFirm.bind(this);
//     this.closeDrawer = this.closeDrawer.bind(this);
//   }

//   componentWillReceiveProps(nextProps) {
//     if (this.props.params.id !== nextProps.params.id) {
//       this.fetch(nextProps.params.id);
//     }
//   }

//   componentDidMount() {
//     this.fetch(this.props.params.id);
//   }

//   closeDrawer() {
//     this.setState({ showDrawer: false, resetDrawer:true});
//   }

//   savedNewFirm(newData) {
//     // select the new item id & close drawer
//     const key = this.state.addNewItemType;
//     const state = {
//       data: { ...this.state.data, [key]: newData.ARCIMEDES_ROW_ID },
//       newFirm: newData,
//     };
//     this.setState(state, () => this.toggleDrawer());
//   }

//   fetch(id) {
//     this.setState({
//       data: null,
//       error: null,
//       success: null,
//     });

//     if (id === undefined) {
//       this.setState({ data: {} });
//       return;
//     }

//     getData({
//       tableCode: AGENTS,
//       options: {
//         filter: [
//           {
//             text: id,
//             code: "ARCIMEDES_ROW_ID",
//             type: "exact",
//           },
//         ],
//       },
//     }).then((res) => {
//       if (res && res.success && Array.isArray(res.data) && res.data.length) {
//         this.setState({
//           data: res.data[0],
//           original: { ...res.data[0] },
//           error: null,
//         });
//       } else {
//         this.setState({
//           data: false,
//           error: res.message ? res.message : "Unidentified Error",
//         });
//       }
//     });
//   }

// fetchUserData(offset) {
//   const options = {
//     limit: {
//       count: limit,
//       offset: offset * limit,
//     },
//     column: [
//       'ARCIMEDES_ROW_ID',
//       'FIRST_NAME',
//       'LAST_NAME',
//       'EMAIL',
//       'PHONE',
//       'DELETED',
//     ]
//   };
//   request(arc.path.api, {
//     service: 'arcimedes',
//     action: 'open.datasource.table.Data.getData',
//     params: ['code', AGENTS, options],
//   }).then(res => {
//     this.setState(prevState => {
//       const users = prevState.users.concat(res.data);
//       return {
//         users,
//       };
//     });
//     if (res.data.length >= limit) {
//       this.fetchUserData(++offset);
//     } else {
//       const isExists = this.state.users.filter(u => (this.state.data.ARCIMEDES_ROW_ID != undefined && this.state.data.ARCIMEDES_ROW_ID != null) ? u.ARCIMEDES_ROW_ID != this.state.data.ARCIMEDES_ROW_ID: true ).find((e) => {
//         return (
//           (e.FIRST_NAME != null && e.FIRST_NAME.toLowerCase()) == (this.state.data.FIRST_NAME != null && this.state.data.FIRST_NAME.toLowerCase()) &&
//           (e.LAST_NAME != null && e.LAST_NAME.toLowerCase()) == (this.state.data.LAST_NAME != null && this.state.data.LAST_NAME.toLowerCase()) )
//       });
//       this.setState({
//         isExists: !!isExists,
//       })
//       if (isExists) {
//         return
//       }
//       else {
//         this.setState({ viewMode: true }, () => this.saveData());
//       }
//     }
//   });
// }
//   async handleSubmit(e) {
//     e.preventDefault();

//     if (this.state.viewMode) this.setState({ viewMode: false });

//     if (
//       this.state.isBusy ||
//       this.state.data.FIRST_NAME === "" ||
//       this.state.data.LAST_NAME === "" ||
//       this.state.viewMode === true
//     ){
//       return;
//     }
//     else {
//       this.fetchUserData(0)
//     }
//   }

//   handleChangeInput(key, value) {
//     this.setState({
//       data: Object.assign(this.state.data, {
//         [key]: value,
//       }),
//     });
//   }

//   saveData() {
//     if (this.state.isBusy) return;

//     this.setState({
//       isBusy: true,
//       error: null,
//       success: null,
//     });

//     return manageData({ tableCode: AGENTS, data: [this.state.data] }).then(
//       (res) => {
//         if (res && res.success) {
//           this.setState(
//             {
//               isBusy: false,
//               success: "Saved",
//             },
//             () => {
//               if (!this.props.edit) {
//                 browserHistory.push({
//                   pathname: `/agent/${res.data[0].ARCIMEDES_ROW_ID}`,
//                 });
//               }
//             }
//           );

//           window.scrollTo(0, 0);
//         } else {
//           this.setState({
//             isBusy: null,
//             error: res && res.message ? res.message : "Unspecified error",
//           });
//         }
//       }
//     );
//   }

//   handleChangeDropdown(query, queryType, x, key) {
//     this.setState({
//       data: Object.assign(this.state.data, {
//         [key]: query[key],
//       }),
//     });
//   }

//   toggleDrawer() {
//     this.setState((prevState) => ({ showDrawer: !prevState.showDrawer, resetDrawer:false }));
//   }

//   addNewItem(addNewItemType) {
//     this.setState({ addNewItemType }, this.toggleDrawer);
//   }

//   render() {
//     const data = this.state.data;
//     const { edit,isSuper } = this.props;

//     return (
//       <CRUD
//         tabsData={[
//           {
//             name: "AGENT",
//             renderedComponent: (
//               <AgentInfo
//                 data={data}
//                 isExists={this.state.isExists}
//                 handleChangeInput={this.handleChangeInput}
//                 handleChangeDropdown={this.handleChangeDropdown}
//                 viewMode={this.state.viewMode}
//                 deleted={data && data.DELETED === "1"}
//                 addNewItem={this.addNewItem}
//                 newFirm={this.state.newFirm}
//               />
//             ),
//           },
//         ]}
//         backLink={`${arc.path.base}agents`}
//         edit={edit}
//         state={this.state}
//         setState={this.setState.bind(this)}
//         handleSubmit={this.handleSubmit}
//         saveData={this.saveData}
//         type="agent"
//         backName="AGENTS"
//         title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
//         isSuper = {isSuper}
//         drawer={
//           <Drawer
//             isOpen={this.state.showDrawer}
//             shouldDisplayChildDrawer={true}
//             reff={this.drawerComponentRef}
//             closeDrawer={this.closeDrawer}
//           >
//             <FirmDrawer
//               savedNewItem={this.savedNewFirm}
//               closeDrawer={this.closeDrawer}
//               resetDrawer={this.state.resetDrawer}
//             />
//           </Drawer>
//         }
//       />
//     );
//   }
// }

//#endregion

import React,{createRef } from "react";
import AgentInfo from "./AgentInfo";
import { browserHistory } from "react-router";
import CRUD from "../CRUD/CRUD";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import Drawer from "../Drawer";
import { ApolloConsumer, useMutation } from "@apollo/client";
import { CREATE_AGENTS } from "../Graphql/mutations";
import { GET_AGENTS, GET_AGENTS_BY_ID, GET_AGENTS_WTH_FILTERS } from "../Graphql/queries";
import { CREATE_OR_UPDATE_CONTACTS_AGENTS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_AGENT_BY_CONTACTID, GET_CONTACT_AGENTS_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import { UserContext } from "../Root/Root";
import AgentCompanyInfo from "./AgentCompanyInfo";
import NotesReusable from "../NotesReusable";
import PeopleGroupsTab from "../PeopleGroupsTab";
import { sanitizeNotesForInput } from "../../utils";

const limit = 1000;

export default class CRUDAgent extends React.Component {
  drawerComponentRef;
  static get contextType() {
    return UserContext;
  }
  constructor(props) {    
    super(props);
    this.state = {
      data: { contact_type: ["Agent"] },
      original: null,
      isBusy: null,
      error: null,
      success: null,
      newFirm: false,
      isExists: false,
      errorTabs: [],
      users: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      showDrawer: false,
      addNewItemType: null,
      resetDrawer: false,
      createAgent: null,
      searchCrudFilter : false,
      filterData: [],
      currentIndex: 0,
      fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
      loggedInUserData:{},
      typeDuplicate:null
    };
    this.client = null;
    this.notesRef = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.saveData = this.saveData.bind(this);
    this.addNewItem = this.addNewItem.bind(this);
    this.savedNewFirm = this.savedNewFirm.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.updateURL = this.updateURL.bind(this);
    this.handleNotesChange = this.handleNotesChange.bind(this)
    this.getCompanyData   = this.getCompanyData.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }
  parseFilterOptions(query){
    const filterObject = {};
    if(query){
        for(const key in query){
            if(key !== 'order' && key !== 'page'){
                filterObject[key]= query[key]
            }
        }
    }
    return [filterObject]
}
  componentDidMount() {
    const userData = this.context.userData;
    this.setState({loggedInUserData: userData});
    if (this.state.fromListUrl) {
      localStorage.setItem('fromListUrl', this.state.fromListUrl);
      this.setState({ fromListUrl: this.state.fromListUrl });
    }
    //#region Below code executes when we click the Last name in MergeDuplicate screen
    const tabParam = this.props.location.query && this.props.location.query.tab;
    if (tabParam && !isNaN(tabParam)) {
      this.setState({ currentTab: parseInt(tabParam.trim(), 10) });
    }
    else {
      this.setState({ currentTab: 0 });
    }
    const queryParams = new URLSearchParams(this.props.location.search);
    queryParams.delete("tab");
    //#endregion
    const hasQuery = queryParams.toString().length > 0;
    if (!hasQuery){
      this.fetch(this.props.params.id);
    }
    if(hasQuery && !tabParam){
      this.setState({ searchCrudFilter: true });
      this.handleQueryChange();
    }
  }
  componentDidUpdate(prevProps) {

    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
    if (hasQuery && prevProps.location.search !== this.props.location.search) {
      this.handleQueryChange();
      this.setState({ searchCrudFilter: true });
    }
    // Check if the query has changed
    // if (prevProps.location.search !== this.props.location.search) {
    //   this.handleQueryChange();
    // }
    if(!hasQuery && prevHasQuery){
      this.fetch(this.props.params.id);
      this.setState({ searchCrudFilter: false });
    }
  }

  handleQueryChange() {
    const query = this.props.location.query;
    const filterOptions = this.parseFilterOptions(query); 
  
    var isNoFilter = Object.keys(filterOptions).length === 0; 
  
    if (isNoFilter) {
      this.fetch(this.props.params.id);
    }
    else{
      this.fetchWithFilter(filterOptions)
    }
  }

handleNotesChange(updatedNotes, editId) {
  const cleanedNotes = updatedNotes
    .filter((note) => note.text && note.text.trim() !== "")
    .filter((note) => {
      // Case 1: new note (no arcimedes_row_id)
      if (!note.arcimedes_row_id) return true;

      // Case 2: edited note (arcimedes_row_id matches editId)
      if (editId && note.arcimedes_row_id === editId) return true;

      // Case 3: deleted note
      if (note.deleted === 1) return true;

      // Skip everything else
      return false;
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
        date,
        ...rest
      }) => rest
    );

  this.setState((prev) => ({
    data: {
      ...prev.data,
      notes: cleanedNotes,
    },
  }));
}

fetchWithFilter(filterOptions) {
  this.setState({
    data: null,
    error: null,
    success: null,
  });

  fetchData(GET_CONTACT_AGENTS_LIST_QUERY, { type:"Agent",filters:filterOptions})
        .then(res => {
          const filterData = res.data.getContacts.data|| [];
          if(filterData.length > 0){
            this.setState({
              // items: res.data.getCompanies.data,
              // totalCount: res.data.getCompanies.totalCount,
              // error: null,
              // isBusy: null,
              filterData,
              currentIndex:0,
              data:  filterData[0],
              original: { ...filterData[0] },
              error: null,
            },() => {
              this.updateURL(filterData[0]);
            });
          }else {
            this.setState({
              filterData: [],
              data: false,
              error: "No filtered data found. Please try again with different filters.",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
    
}

  closeDrawer() {
    this.setState({ showDrawer: false, resetDrawer: true });
  }

savedNewFirm(newData) {
  const key = this.state.addNewItemType;
  if (!newData) return;

  this.setState((prevState) => {
    let updatedData = {
      ...prevState.data,
      [key]: newData.arcimedes_row_id,
    };

    if (key === "firm") {
      updatedData = {
        ...updatedData,
        company_address: newData.address || "",
        company_city: newData.city || "",
        company_state: newData.state || "",
        company_zip: newData.zip ? newData.zip.toString() : "",
        website: newData.website || "",
        firm: newData.arcimedes_row_id || "",
      };
    }

    return {
      data: updatedData,
      newFirm: newData,
    };
  }, () => this.toggleDrawer());
}


  fetch(id) {
    if (this.client) {
      this.setState({
        // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader 
        error: null,
        success: null,
      });

      if (id === undefined) {
        this.setState({ data: { contact_type: ["Agent"] } });
        return;
      }
      // const token = localStorage.getItem('authToken');

      // this.client
      //   .query({
      //     query: GET_AGENTS_BY_ID,
      //     variables: { arcimedes_row_id: id },
      //     fetchPolicy: "no-cache",
      //     context: {
      //       headers: {
      //         authorization: `Bearer ${token}`,
      //       },
      //     },
      //   })
      fetchData(GET_AGENT_BY_CONTACTID, { contactid: parseInt(id) })
        .then((res) => {
          if (res && res.data && res.data.getContactByContactid) {
            let data = res.data.getContactByContactid.contact;
            data.contact_type = data.contact_type && data.contact_type.join(",");
            data['hsc_hot_list'] = res.data.getContactByContactid.contact.hsc_id && res.data.getContactByContactid.contact.hsc_id.includes(this.state.loggedInUserData.email) ? '1' : '0';
            this.setState({
              data: data,
              original: { ...data },
              error: null,
            });
          } else {
            this.setState({
              data: false,
              error: res.errors ? res.errors[0].message : "Unidentified Error",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
    }
  }


  async fetchUserData(client) {
    const token = localStorage.getItem('authToken');
    try {
      // const res = await client.query({
      //   // query: GET_AGENTS_WTH_FILTERS,
      //   // variables: { pageOptions: { page: 1, pageSize: 20000 }, filters: [], sortOptions: [] },
      //   query: GET_CONTACT_AGENTS_LIST_QUERY,
      //   variables: { type: "Agent",pageOptions: { page: 1, pageSize: 20000 }, filters: [], sortOptions: [] },
      //   fetchPolicy: "no-cache",
      //   context: {
      //     headers: {
      //       authorization: `Bearer ${token}`,
      //     },
      //   },
      // });
      const res = await fetchData(GET_CONTACT_AGENTS_LIST_QUERY, { type: "Agent", pageOptions: { page: 1, pageSize: 20000 }, filters: [], sortOptions: [] })
      // if (res.data && res.data.getAgents.agents && res.data.getAgents.agents.length) {
      //   const isExists = res.data.getAgents.agents.some((agent) => {
      if (res.data && res.data.getContacts.data && res.data.getContacts.data.length) {
        const isExists = res.data.getContacts.data.some((agent) => {
          const agentFirstName = agent.first_name ? agent.first_name.toLowerCase() : null;
          const agentLastName = agent.last_name ? agent.last_name.toLowerCase() : null;
          const stateFirstName = this.state.data.first_name ? this.state.data.first_name.toLowerCase() : null;
          const stateLastName = this.state.data.last_name ? this.state.data.last_name.toLowerCase() : null;

          return (
            agentFirstName === stateFirstName &&
            agentLastName === stateLastName &&
            agent.arcimedes_row_id !== this.state.data.arcimedes_row_id
          );
        });
        this.setState({ 
          isExists 
        });
        return isExists;
      }

      return false;
    } catch (error) {
      console.error("Error fetching users for duplicate validation:", error);
      return false;
    }
  }

  // async fetchUserData(client) {
  //   const token = localStorage.getItem('authToken');
  //   try {
  //     const res = await client.query({
  //       query: GET_AGENTS_WTH_FILTERS,
  //       // variables: { page: 1, pageSize: 100 },
  //       variables: { pageOptions: {page: 1, pageSize: 20000},filters:[], sortOptions: [] }, 
  //       fetchPolicy: "no-cache",
  //       context: {
  //         headers: {
  //           authorization: `Bearer ${token}`,
  //         },
  //       },
  //     });

  //     if (res.data && res.data.getAgents.agents && res.data.getAgents.agents.length) {
  //       const isExists = res.data.getAgents.agents.some((agent) =>{
  //         console.log(agent)
  //         agent.first_name.toLowerCase() === this.state.data.first_name.toLowerCase() &&
  //         agent.last_name.toLowerCase() === this.state.data.last_name.toLowerCase() &&
  //         agent.arcimedes_row_id !== this.state.data.arcimedes_row_id
  //       }
  //       );
  //       this.setState({ isExists });
  //       return isExists;
  //     }

  //     return false;
  //   } catch (error) {
  //     console.error("Error fetching users for duplicate validation:", error);
  //     return false;
  //   }
  // }

  updateURL(data) {
    const queryParams = new URLSearchParams(this.props.location.search);
    // const name = queryParams.get("name");
    // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
    const newUrl = `/agent/${data.contact_id}?${queryParams.toString()}`;
    browserHistory.push(newUrl);
  }


  async handleSubmit(client, e) {

    e.preventDefault();
    this.setState({
      isExists:false,
      typeDuplicate:null
    });
    if (this.state.viewMode) this.setState({ viewMode: false });
 if (this.notesRef.current && this.notesRef.current.validateNotes) {
  const isValid = this.notesRef.current.validateNotes();
  if (!isValid){
      console.log("Stop submit: notes invalid");
     return;
  }
}
    if (!this.state.data.first_name ||
      !this.state.data.last_name) {
      this.setState({ errorTabs: [0], success: null });
      return;
    }
    if (
      this.state.isBusy ||
      this.state.data.first_name === "" ||
      this.state.data.last_name === "" ||
      this.state.viewMode === true
    ) {
      return;
    }
    else {
      //this.fetchUserData(0)
      // const isDuplicate = await this.fetchUserData(client);
      // if (isDuplicate) {
      //   console.log("Duplicate entry detected.");
      //   return; 
      // }
      if (!this.props.params.id) {
        const loggedInUserId = this.state.loggedInUserData.id;
        const loggedInUserEmail = this.state.loggedInUserData.email;
        var pageParams = {
          page: 1,
          pageSize: 50 
        };
        const input = {
          first_name: this.state.data.first_name,
          last_name: this.state.data.last_name,
          email: this.state.data.email,
          phone: this.state.data.phone,
          cell_phone: this.state.data.cell_phone,
          firm: this.state.data.firm ? this.state.data.firm.toString() : this.state.data.firm,
          // contact_type: "Agent",
          // deleted: this.state.data.deleted
          contact_type: Array.isArray(this.state.data.contact_type)
          ? this.state.data.contact_type
          : typeof this.state.data.contact_type === "string"
          ? this.state.data.contact_type.split(",")
          : ["Agent"],
          address: this.state.data.address,
          city: this.state.data.city,
          state: this.state.data.state,
          zip: this.state.data.zip,
          name:this.state.data.name ? this.state.data.name : null,
          notes: sanitizeNotesForInput(this.state.data.notes),
          hsc_id : this.state.data.hsc_hot_list === '1'? String(loggedInUserEmail) : null,

          company_address: this.state.data.company_address,
          company_city: this.state.data.company_city,
          company_state: this.state.data.company_state,
          company_zip: this.state.data.company_zip,
          website: this.state.data.website ? this.state.data.website:'' ,
        }
        const token = localStorage.getItem('authToken');
        try {
          // const res = await client.mutate({
          //   //mutation: CREATE_AGENTS,
          //   // variables: {
          //   //   first_name: this.state.data.first_name,
          //   //   last_name: this.state.data.last_name,
          //   //   email: this.state.data.email,
          //   //   phone: this.state.data.phone,
          //   //   cell_phone: this.state.data.cell_phone,
          //   //   firm: this.state.data.firm,
          //   //   // deleted: this.state.data.deleted
          //   // },
          //   mutation: CREATE_OR_UPDATE_CONTACTS_AGENTS,
          //   variables: {
          //     input:{
          //     arcimedes_row_id:this.state.data.arcimedes_row_id ? this.state.data.arcimedes_row_id : Math.floor(Math.random() * 100).toString(),
          //     first_name: this.state.data.first_name,
          //     last_name: this.state.data.last_name,
          //     email: this.state.data.email,
          //     phone: this.state.data.phone,
          //     cell_phone: this.state.data.cell_phone,
          //     firm: this.state.data.firm,
          //     contact_type:"Agent"
          //     // deleted: this.state.data.deleted
          //     }
          //   },
          //   context: {
          //     headers: {
          //       // authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InByYXZpcHVkaUBzYWdlaXRpbmMuY29tIiwiaWQiOjMyOSwicm9sZSI6IlN1cGVyIFVzZXIiLCJpYXQiOjE3MjU2MjM0MDAsImV4cCI6MTcyODIxNTQwMH0.cmuEOr-82RKRMTymgB21ZlOJP09mtWOxW50hszQ8ADU', // Bearer token added here
          //       authorization: `Bearer ${token}`,
          //     },
          //   },
          //   // refetchQueries: [{ query: GET_AGENTS, variables: { pageOptions: pageParams } }],
          // });
          const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_AGENTS, { input })
          if (res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.success ){
          this.setState({ viewMode: true });
          browserHistory.push({
            //pathname: `/agent/${res.data.createOrUpdateAgent.agent.arcimedes_row_id}`,
            pathname: `/agent/${res.data.createOrUpdateContact.contact.contact_id}`,
          });
        }
        else if(res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error && res.data.createOrUpdateContact.error.includes("already exists")){
          this.setState({
          isExists:true,
          typeDuplicate:res.data.createOrUpdateContact.error,
          viewMode:false
        })
        }

        } catch (error) {
          console.error("Error in handleSubmit:", error);
        }
      }
      else {
        this.setState({ viewMode: true }, () => this.saveData(client));
      }
    }
  }
  handleChangeInput (key, value)  {
    this.setState((prevState) => {
        let newValue;

        if (key === "hsc_hot_list") {
            newValue = prevState.data[key] === "1" ? "0" : "1"; // Toggle between "1" and "0"
        } else {
            newValue = value;
        }

        return {
            data: {
                ...prevState.data,
                [key]: newValue,
                
            }
        };
    });
  }
 /*  handleChangeInput(key, value) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [key]: value
      }
    }));
  } */

  async saveData(client) {
    if (this.state.isBusy) return;
    const newData = { ...this.state.data };  
    const loggedInUserId = this.state.loggedInUserData.id;
    const loggedInUserEmail = this.state.loggedInUserData.email;

   if (newData["hsc_hot_list"] === "1") {
    let hotListAgents = [];

    if (newData.hsc_id) {
        hotListAgents = newData.hsc_id
            .split(",")
            .map(id => id.trim())
            .filter((id, index, self) => id && self.indexOf(id) === index); // removes duplicates
    }

    const loggedInIdStr = String(loggedInUserEmail);

    if (!hotListAgents.includes(loggedInIdStr)) {
        hotListAgents.push(loggedInIdStr);
    }

    newData.hsc_id = hotListAgents.join(",");
} 
else if (newData["hsc_hot_list"] === "0") {
    if (newData.hsc_id) {
        const loggedInIdStr = String(loggedInUserId);
         const loggedInUserEmailStr = String(loggedInUserEmail);
          let followUpList = newData.hsc_id ? newData.hsc_id.split(",") : [];
          let hotListAgents = followUpList.filter(email => email.trim() !== loggedInUserEmailStr);
          newData.hsc_id = hotListAgents.length > 0 ? hotListAgents.join(",") : "";
    }
}
    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    var pageParams = {
      page: 1,
      pageSize: 50
    }

    try {
      const token = localStorage.getItem('authToken');
      // const res = await client.mutate({
      //   // mutation: CREATE_AGENTS,
      //   // variables: {
      //   //   arcimedes_row_id: this.props.params.id,
      //   //   first_name: this.state.data.first_name,
      //   //   last_name: this.state.data.last_name,
      //   //   email: this.state.data.email,
      //   //   phone: this.state.data.phone,
      //   //   cell_phone: this.state.data.cell_phone,
      //   //   firm: this.state.data.firm,
      //   //   deleted: this.state.data.deleted
      //   // },
      //   mutation: CREATE_OR_UPDATE_CONTACTS_AGENTS,

      //   variables: {
      //     input:{
      //     first_name: this.state.data.first_name,
      //     last_name: this.state.data.last_name,
      //     email: this.state.data.email,
      //     phone: this.state.data.phone,
      //     cell_phone: this.state.data.cell_phone,
      //     firm: this.state.data.firm,
      //     deleted: this.state.data.deleted,
      //     contact_type:"Agent",
      //     contact_id: this.state.data.contact_id
      //     }
      //   },
      //   context: {
      //     headers: {
      //       authorization: `Bearer ${token}`,  // Bearer token added here
      //     },
      //   },
      //   // refetchQueries: [{ query: GET_AGENTS, variables: {pageOptions: pageParams} }],
      // });
      const input = {
        first_name: this.state.data.first_name,
        last_name: this.state.data.last_name,
        email: this.state.data.email,
        phone: this.state.data.phone,
        cell_phone: this.state.data.cell_phone,
        firm: this.state.data.firm ? this.state.data.firm.toString() : this.state.data.firm,
        deleted: this.state.data.deleted,
        // contact_type: "Agent",
        contact_id: this.props.params.id,
        // contact_type: this.state.data.contact_type.length > 1 ?  this.state.data.contact_type.split(",") : ["Agent"],
        contact_type: Array.isArray(this.state.data.contact_type)
        ? this.state.data.contact_type
        : typeof this.state.data.contact_type === "string"
        ? this.state.data.contact_type.split(",")
        : ["Agent"],
        address: this.state.data.address,
        city: this.state.data.city,
        state: this.state.data.state,
        zip: this.state.data.zip,
        name:this.state.data.contact_type.includes("Lender") && this.state.data.name ? this.state.data.name : null,
        notes: sanitizeNotesForInput(this.state.data.notes),
        hsc_id :newData.hsc_id?String(newData.hsc_id):null,

        company_address: this.state.data.company_address,
        company_city: this.state.data.company_city,
        company_state: this.state.data.company_state,
        company_zip: this.state.data.company_zip,
        website: this.state.data.website ? this.state.data.website:'' ,
      };
      const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_AGENTS, { input })
        if (res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.success ){
          const loggedInUserId = this.state.loggedInUserData.id;
          const loggedInUserEmail = this.state.loggedInUserData.email;
          res.data.createOrUpdateContact.contact['hsc_hot_list'] = res.data.createOrUpdateContact.contact.hsc_id && res.data.createOrUpdateContact.contact.hsc_id.includes(loggedInUserEmail) ? '1' : '0';
        this.setState({
          data:res.data.createOrUpdateContact.contact,
          isBusy: false,
          success: "Saved",
        }, () => {
          if (!this.props.edit) {
            browserHistory.push({
              //pathname: `/agent/${res.data.createOrUpdateAgent.agent.arcimedes_row_id}`,
              pathname: `/agent/${res.data.createOrUpdateContact.contact.contact_id}`,
            });
          }
        });
      }
      else if(res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error && res.data.createOrUpdateContact.error.includes("already exists")){
        this.setState({
        isExists:true,
        typeDuplicate: res.data.createOrUpdateContact.error,
        viewMode:false
      })
      }
      window.scrollTo(0, 0);
    } catch (error) {
      console.error("Error in saveData:", error);
      this.setState({
        isBusy: false,
        error: error.message || "Unspecified error",
      });
    }
  }

  getCompanyData(data, id) {
  return data.find(item => item.ARCIMEDES_ROW_ID === id);
}


  handleChangeDropdown(query, queryType, x, key) {
    const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());
if (queryType == "firm") { // agent company dropdown autofill details.
  const companiesData = JSON.parse(
    sessionStorage.getItem("companyData") || "[]"
  );
  const result = this.getCompanyData(companiesData, x);
  this.setState((prevState) => ({
    data: {
      ...prevState.data,
      company_address: result ? result.ADDRESS : "",
      company_city: result ? result.CITY : "",
      company_state: result ? result.STATE : "",
      company_zip: result &&  result.ZIP ? result.ZIP.toString() : "",
      website: result ? result.WEBSITE : "",
    },
  }));
}
    if (key === "contact_type" && this.state.typeDuplicate) {
      const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
      const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

      const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
      if (!hasMatch) {
        this.setState({
          isExists: false,
          typeDuplicate: null,
          isBusy:false
        });
      }
    }
    
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [key]: query[key]
      }
    }));
  }

  toggleDrawer() {
    this.setState((prevState) => ({ showDrawer: !prevState.showDrawer, resetDrawer: false }));
  }

  addNewItem(addNewItemType) {
    this.setState({ addNewItemType }, this.toggleDrawer);
  }

  render() {
    const data = this.state.data;
    const { edit, isSuper } = this.props;
    return (
      <ApolloConsumer>
        {client => {
          if (!this.client) this.client = client;
          return (
            <CRUD
              tabsData={[
                {
                  name: "AGENT",
                  renderedComponent: (
                    <AgentInfo
                      data={data}
                      isExists={this.state.isExists}
                      handleChangeInput={this.handleChangeInput}
                      handleChangeDropdown={this.handleChangeDropdown}
                      viewMode={this.state.viewMode}
                      deleted={data && data.DELETED === 1}
                      addNewItem={this.addNewItem}
                      newFirm={this.state.newFirm}
                      handleParentDropdownChange={this.handleChangeDropdown}
                      typeDuplicate={this.state.typeDuplicate}
                    />
                  ),
                },
                {
                  name: "Agent Company",
                  renderedComponent: (
                    <AgentCompanyInfo
                      data={data}
                      handleChangeInput={this.handleChangeInput}
                      handleChangeDropdown={this.handleChangeDropdown}
                      viewMode={this.state.viewMode}
                      deleted={data && data.deleted === "1"}
                      addNewItem={this.addNewItem}
                      newFirm={this.state.newFirm}
                      setState={this.setState.bind(this)}
                    />
                  ),
                },
                {
                  name: "PEOPLE GROUPS",
                  renderedComponent: (
                    <PeopleGroupsTab
                      data={data}
                      viewMode={this.state.viewMode}
                    ownerAgentId={this.state.loggedInUserData && this.state.loggedInUserData.id}
                  />
                  ),
                },
              {
                    name: "NOTES",
                    renderedComponent: (
                      <NotesReusable
                      data={data}
                        notes={data && data.notes ? data.notes : []}
                        contact_id={
                          data && data.contact_id ? data.contact_id : null
                        }
                        viewMode={this.state.viewMode}
                        handleChangeInput={this.handleChangeInput}
                        ref={this.notesRef}
                        //deleted={data && data.DELETED === "1"}
                        deleted={data && data.deleted === "1"}
                        setState={this.setState.bind(this)}
                        onNotesChange={this.handleNotesChange}
                          state={this.state}
                      />
                    ),
                  },
              ]}
              backLink={`${arc.path.base}contacts/agents`}
              edit={edit}
              state={this.state}
              setState={this.setState.bind(this)}
              handleSubmit={this.handleSubmit.bind(this, client)}
              saveData={() => this.saveData(client)}
              type="agent"
              backName="AGENTS"
              title={data && `${data.first_name} ${data.last_name}`}
              isSuper={isSuper}
              filterData={this.state.filterData}
              currentIndex={this.state.currentIndex}
              updateURL={this.updateURL}
              // backToUrl={"/agents"}
              backToUrl={
                this.state.fromListUrl ? this.state.fromListUrl : "/agents"
              }
              drawer={
                <Drawer
                  isOpen={this.state.showDrawer}
                  shouldDisplayChildDrawer={true}
                  reff={this.drawerComponentRef}
                  closeDrawer={this.closeDrawer}
                >
                  <FirmDrawer
                    savedNewItem={this.savedNewFirm}
                    closeDrawer={this.closeDrawer}
                    resetDrawer={this.state.resetDrawer}
                  />
                </Drawer>
              }
            />
          );
        }
        }
      </ApolloConsumer>
    );
  }
}
